export * from './listView/list-view.component';
export * from './searchList/search-list.component';
export * from './sortList/sort-list.component';

import { ListView } from './listView/list-view.component';
import { SearchList } from './searchList/search-list.component';
import { SortList } from './sortList/sort-list.component';


export const LIST_VIEW_COMPONENTS: [any, any, any] = [ListView, SearchList, SortList];


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/listView/index.ts